module.exports = __webpack_public_path__ + "static/media/IOSArrowRight.8c75fab7.svg";